module.exports = __webpack_public_path__ + "img/nav-right-expand-search-nissan.24fb0074.png";